import { IsEnum, IsNotEmpty, IsNumber, IsOptional } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
import { OccupancyEnum } from '@gtpl/shared-models/masters';
export class PalletDTO {
    @ApiProperty()
    @IsNotEmpty({ message: "Plant Id should not be empty" })
    @IsNumber()
    plantId: number;

    @ApiProperty()
    @IsNotEmpty({ message: "Associate RFIS's should not be empty" })
    assocRfId: string;

    @ApiProperty({
        enum: OccupancyEnum,
        default: OccupancyEnum.NOT_OCCUPIED
    })
    @IsEnum(OccupancyEnum)
    occupancy: OccupancyEnum;

    @ApiProperty()
    @IsNotEmpty({ message: "Created user should not be empty" })
    createdUser: string;
}